import {
    LinkoutButton,
    LinkoutButtonText,
} from "@shared/Components/Tippspiel/TippspileLinkoutButton/TippspielLinkoutButton.styles";
import { TippspielChevronRightIcon } from "@icons/TippspielChevronRightIcon";

export function TippspielLinkoutButton({
    onClick,
    text,
}: {
    onClick: () => void;
    text: string;
}) {
    return (
        <LinkoutButton
            disableRipple
            className={"fontFamily-inherited"}
            onClick={onClick}
            variant={"text"}
        >
            <LinkoutButtonText className={"fontFamily-inherited"}>
                {text}
            </LinkoutButtonText>
            <TippspielChevronRightIcon />
        </LinkoutButton>
    );
}
